import React from 'react';
import DashboardShell from '../../layouts/DashboardShell';

function Stat({ label, value }) {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
      <p className="text-xs font-semibold text-slate-500">{label}</p>
      <p className="mt-2 text-2xl font-bold text-navy">{value}</p>
    </div>
  );
}

function AdminDashboardPage() {
  return (
    <DashboardShell
      role="ADMIN"
      sideLinks={[
        { to: '/admin', label: 'Dashboard' },
        { to: '/admin/users', label: 'Users' },
        { to: '/admin/jobs', label: 'Jobs' },
        { to: '/admin/payments', label: 'Payments' },
        { to: '/admin/verifications', label: 'Verifications' },
        { to: '/admin/analytics', label: 'Analytics' },
        { to: '/admin/logs', label: 'Logs' },
        { to: '/admin/reports', label: 'Reports' },
        { to: '/admin/profile', label: 'Profile' },
        { to: '/admin/settings', label: 'Settings' },
      ]}
      rightPanel={
        <div className="rounded-3xl bg-white p-6 shadow-sm">
          <p className="text-sm font-semibold text-navy">System notices</p>
          <ul className="mt-3 space-y-2 text-sm text-slate-700">
            <li className="flex justify-between"><span>Pending reports</span><span className="font-semibold">4</span></li>
            <li className="flex justify-between"><span>Pending verifications</span><span className="font-semibold">7</span></li>
          </ul>
        </div>
      }
    >
      <div className="rounded-3xl bg-white p-6 sm:p-8 shadow-sm">
        <p className="text-sm font-semibold text-slate-500">Welcome back</p>
        <p className="mt-2 text-sm text-slate-600">System monitoring, moderation, analytics.</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="Total Users" value="1,240" />
        <Stat label="Active Jobs" value="186" />
        <Stat label="Revenue" value="K18,920" />
        <Stat label="Pending Reports" value="4" />
      </div>

      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <h2 className="text-lg font-bold text-navy">Recent activities</h2>
        <div className="mt-4 overflow-x-auto">
          <table className="min-w-full text-left text-sm">
            <thead className="text-xs uppercase text-slate-500">
              <tr>
                <th className="py-2 pr-4">Event</th>
                <th className="py-2 pr-4">Time</th>
                <th className="py-2 pr-4">Status</th>
              </tr>
            </thead>
            <tbody className="text-slate-700">
              <tr className="border-t border-slate-100">
                <td className="py-3 pr-4">Worker registered</td>
                <td className="py-3 pr-4">2 mins ago</td>
                <td className="py-3 pr-4"><span className="rounded-2xl bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">OK</span></td>
              </tr>
              <tr className="border-t border-slate-100">
                <td className="py-3 pr-4">Job flagged</td>
                <td className="py-3 pr-4">18 mins ago</td>
                <td className="py-3 pr-4"><span className="rounded-2xl bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-700">Review</span></td>
              </tr>
              <tr className="border-t border-slate-100">
                <td className="py-3 pr-4">Payment completed</td>
                <td className="py-3 pr-4">1 hour ago</td>
                <td className="py-3 pr-4"><span className="rounded-2xl bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">OK</span></td>
              </tr>
              <tr className="border-t border-slate-100">
                <td className="py-3 pr-4">Account suspended</td>
                <td className="py-3 pr-4">Today</td>
                <td className="py-3 pr-4"><span className="rounded-2xl bg-rose-50 px-3 py-1 text-xs font-semibold text-rose-700">Actioned</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </DashboardShell>
  );
}

export default AdminDashboardPage;

